import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  movie: any;
  @Input() getDemoStatus: boolean;
  @Output() getDemoStatusChange = new EventEmitter<boolean>();

  constructor() {
  }

  showDemo() {
    this.movie = document.getElementById('movie');
    this.getDemoStatus = true;
    this.getDemoStatusChange.emit(true);
    this.movie.play();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/nav/nav.component.ts